import { BookPlusIcon } from './BookPlusIcon';

/**
 * author: Simran
 * id 3C49BDB2-C3A3-4E0C-9314-19FE66414A5B
 * name book-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-plus.svg
 * tags
 */
export const BookAddIcon = BookPlusIcon;
export default BookAddIcon